import { COUNTRY } from '@/config/index';


export const isEnvironmentCountry = country => COUNTRY.toLowerCase() === country;
